var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoryBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2560,
    height: 263
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "CategoryBackground_svg__a",
    d: "M0 0h2560v263H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "CategoryBackground_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CategoryBackground_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#1B92F5",
    xlinkHref: "#CategoryBackground_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12 1411.687 11862.612)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M18.259 24.448L39.17 13.07a10.372 10.372 0 019.93.01l20.778 11.364a5.186 5.186 0 012.697 4.549v15.68c0 10.01-5.468 19.22-14.256 24.014L46.546 75.11a5.182 5.182 0 01-4.964 0l-11.774-6.422a27.355 27.355 0 01-14.256-24.015V29.001a5.181 5.181 0 012.707-4.553z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M18.259 24.448L39.17 13.07a10.372 10.372 0 019.93.01l20.778 11.364a5.186 5.186 0 012.697 4.549v15.68c0 10.01-5.468 19.22-14.256 24.014L46.546 75.11a5.182 5.182 0 01-4.964 0l-11.774-6.422a27.355 27.355 0 01-14.256-24.015V29.001a5.181 5.181 0 012.707-4.553z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M64.8 44.752a20.045 20.045 0 01-10.368 17.554l-9.117 5.026m-11.619-5.026a20.045 20.045 0 01-10.368-17.554V32.404c0-.946.515-1.816 1.343-2.272l13.596-7.475m22.03-19.571A43.962 43.962 0 0044.064 0C19.728 0 0 19.728 0 44.064m23.881 39.18a43.87 43.87 0 0020.183 4.884c24.336 0 44.064-19.728 44.064-44.064"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.552,
    cy: 77.76,
    r: 5.184,
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.552,
    cy: 77.76,
    r: 5.184,
    fill: "#FFF",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 2590.76 -17626.578)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.12,
    cy: 15.12,
    r: 15.12,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.12 16.632c5.359 0 9.904 3.485 11.492 8.312A15.08 15.08 0 0115.12 30.24c-4.6 0-8.72-2.054-11.493-5.295 1.589-4.828 6.134-8.313 11.493-8.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M15.12 16.632c5.359 0 9.904 3.485 11.492 8.312A15.08 15.08 0 0115.12 30.24c-4.6 0-8.72-2.054-11.493-5.295 1.589-4.828 6.134-8.313 11.493-8.313z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.12,
    cy: 10.584,
    r: 6.048,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.008
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.12,
    cy: 10.584,
    r: 6.048,
    fill: "#FFF",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.104 63.504a6.048 6.048 0 00-6.048 6.048v30.24a6.048 6.048 0 006.048 6.048h86.688a6.048 6.048 0 006.048-6.048v-9.071l7.09-4.283a2.016 2.016 0 000-3.451l-7.09-4.283v-9.152a6.048 6.048 0 00-6.048-6.048H13.104z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.552,
    height: 3.024,
    x: 20.664,
    y: 77.112,
    stroke: "#FFF",
    strokeWidth: 1.008,
    rx: 1.512
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.56,
    height: 4.032,
    x: 20.16,
    y: 76.608,
    fill: "#FFF",
    fillOpacity: 0.3,
    rx: 2.016
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.008,
    d: "M133.056 9.072a6.048 6.048 0 016.048 6.048v30.24a6.048 6.048 0 01-6.048 6.048H50.4a6.048 6.048 0 01-6.048-6.048v-9.071l-7.09-4.283a2.016 2.016 0 010-3.451l7.09-4.283V15.12A6.048 6.048 0 0150.4 9.072h82.656z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M133.056 9.072a6.048 6.048 0 016.048 6.048v30.24a6.048 6.048 0 01-6.048 6.048H50.4a6.048 6.048 0 01-6.048-6.048v-9.071l-7.09-4.283a2.016 2.016 0 010-3.451l7.09-4.283V15.12A6.048 6.048 0 0150.4 9.072h82.656z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.56,
    height: 3.032,
    x: 55.94,
    y: 22.676,
    stroke: "#FFF",
    rx: 1.516
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.336,
    height: 3.032,
    x: 55.94,
    y: 34.772,
    stroke: "#FFF",
    rx: 1.516
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-39 1296.13 -3068.282)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M155.912 16.634c12.87 4.94 19.297 19.377 14.357 32.247-4.94 12.87-19.377 19.297-32.247 14.357a24.855 24.855 0 01-9.455-6.429l-8.345-1.044a2.496 2.496 0 01-1.738-3.904l4.22-6.058a24.85 24.85 0 01.961-14.812c4.94-12.87 19.378-19.297 32.247-14.357z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M155.912 16.634c12.87 4.94 19.297 19.377 14.357 32.247-4.94 12.87-19.377 19.297-32.247 14.357a24.836 24.836 0 01-10.688-7.884l-7.112-.89a2.495 2.495 0 01-1.738-3.903l4.002-5.744a24.837 24.837 0 011.179-13.826c4.94-12.87 19.378-19.297 32.247-14.357z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.349 26.672)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.322 19.724a6.24 6.24 0 00-3.59-8.062m9.415 10.298c2.47-6.434-.744-13.653-7.179-16.123m13.005 18.36C23.678 14.545 18.857 3.717 9.205.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.548,
    cy: 17.54,
    r: 1.3,
    fill: "#FFF",
    transform: "rotate(21 2.548 17.54)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M96.516 21.252a8 8 0 014.781 10.254L95.924 46.27h0c-11.659-4.243-24.55 1.768-28.793 13.426-4.243 11.659 1.768 24.55 13.426 28.793l-11.35 31.183a8 8 0 01-10.253 4.781l-50.638-18.43a8 8 0 01-4.781-10.254l32.09-88.166a7.999 7.999 0 0110.253-4.782l50.638 18.431z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M99.936 35.247L95.924 46.27h0c-11.659-4.243-24.55 1.768-28.793 13.426-4.243 11.659 1.768 24.55 13.426 28.793l-7.939 21.813L6.945 86.399l27.318-75.055 65.673 23.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M43.829 14.766l17.997 38.347c.253.539.895.773 1.435.523s.773-.89.52-1.428L46.699 15.81l11.338 4.127 8.935 19.037c.252.54.895.773 1.435.523s.772-.89.52-1.428l-8.02-17.088 39.16 14.253-3.972 10.913c-11.587-3.736-24.146 2.34-28.345 13.876-4.198 11.536 1.517 24.264 12.794 28.85l-8.044 22.1-13.788-5.018L43.69 73.948a1.083 1.083 0 00-1.435-.522c-.54.25-.773.89-.52 1.428l14.107 30.057L6.533 86.965 34.1 11.225l9.729 3.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B92F5",
    fillOpacity: 0.3,
    d: "M36.304 104.256a3.745 3.745 0 011.057 6.444 3.744 3.744 0 01-3.076-6.597 3.738 3.738 0 012.019.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M95.17 45.788c11.657 4.243 17.669 17.134 13.425 28.792A22.38 22.38 0 0197.903 86.8 16.37 16.37 0 0087.12 72.284c-6.868-2.5-14.308-.155-18.525 5.286a22.67 22.67 0 009.128 9.561c-10.277-4.944-15.33-16.973-11.346-27.917 4.243-11.658 17.134-17.67 28.792-13.426zm-12.26 14.34a7.488 7.488 0 1014.074 5.12 7.488 7.488 0 00-14.074-5.12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M102.916 50.364a22.434 22.434 0 00-6.992-4.094c-11.659-4.243-24.55 1.768-28.793 13.426-4.243 11.659 1.768 24.55 13.426 28.793 11.659 4.243 24.55-1.768 28.793-13.426a22.348 22.348 0 001.045-11.42m-1.318-4.658a22.481 22.481 0 00-1.605-3.216"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.623,
    cy: 107.028,
    r: 3.744,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(20 36.623 107.028)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(16 652.424 6732.986)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M53.45 4.751a4.75 4.75 0 014.751 4.751v42.76a4.752 4.752 0 01-4.75 4.752H13.065a4.753 4.753 0 01-4.752-4.752H48.7a4.75 4.75 0 004.751-4.75h0V4.751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M53.45 4.752h-.067a4.75 4.75 0 014.751 4.75v42.76a4.752 4.752 0 01-4.75 4.752H13.065a4.753 4.753 0 01-4.752-4.752H48.7a4.75 4.75 0 004.751-4.75V4.751z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M48.7 0a4.75 4.75 0 014.75 4.751v42.76a4.75 4.75 0 01-4.75 4.751H8.313a4.75 4.75 0 01-4.75-4.75V37.414h1.781c.935 0 1.701-.72 1.776-1.635l.006-.146c0-.984-.798-1.782-1.782-1.782h0l-1.782-.001v-8.314h1.782c.935 0 1.701-.72 1.776-1.635l.006-.146c0-.935-.72-1.702-1.636-1.776l-.146-.006H3.563v-8.315h1.782c.935 0 1.701-.72 1.776-1.635l.006-.146c0-.935-.72-1.702-1.636-1.776l-.146-.006H3.563V4.751A4.752 4.752 0 018.314 0H48.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.943,
    height: 3.751,
    x: 12.378,
    y: 10.002,
    stroke: "#FFF",
    rx: 1.876
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.127,
    height: 3.563,
    y: 10.096,
    stroke: "#FFF",
    rx: 1.782
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.127,
    height: 3.563,
    y: 21.974,
    stroke: "#FFF",
    rx: 1.782
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.127,
    height: 3.563,
    y: 33.852,
    stroke: "#FFF",
    rx: 1.782
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.44,
    height: 3.76,
    x: 12.126,
    y: 10.493,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.446,
    height: 3.751,
    x: 12.378,
    y: 21.88,
    stroke: "#FFF",
    rx: 1.876
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.84,
    height: 3.76,
    x: 11.74,
    y: 22.371,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.446,
    height: 3.751,
    x: 12.378,
    y: 33.758,
    stroke: "#FFF",
    rx: 1.876
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.9,
    height: 3.76,
    x: 12.68,
    y: 34.249,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 1.88
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(13 259.972 6606.512)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M31.107 9.435c9.974 0 18.06 8.073 18.06 18.032h-18.06V9.435z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M27.495 13.041v18.034h18.06c0 9.959-8.086 18.032-18.06 18.032-9.974-.001-18.06-8.074-18.06-18.032 0-9.96 8.086-18.033 18.06-18.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M27.495 13.041v18.034h18.06c0 9.959-8.086 18.032-18.06 18.032-9.974-.001-18.06-8.074-18.06-18.032 0-9.96 8.086-18.033 18.06-18.033z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.393 19.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 14.4,
    x: -6.462,
    y: 7.97,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 2.359,
    transform: "rotate(-90 7.938 15.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.484,
    height: 14.152,
    x: -6.68,
    y: 7.752,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 2.359,
    transform: "rotate(-90 8.062 14.828)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.296 10.304)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8,
    height: 14.4,
    x: -11.048,
    y: 12.54,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 2.359,
    transform: "rotate(-90 7.852 19.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.74,
    height: 14.152,
    x: -10.894,
    y: 12.694,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 2.359,
    transform: "rotate(-90 7.976 19.77)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M101.425 0a4.717 4.717 0 014.717 4.717v54.251h-74.3a4.718 4.718 0 00-4.712 4.502l-.005.215v4.717H4.717A4.715 4.715 0 010 63.686V4.717A4.717 4.717 0 014.717 0h96.708z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87.273,
    height: 40.098,
    x: 27.125,
    y: 58.968,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    rx: 4.717
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M109.68 58.968a4.717 4.717 0 014.718 4.717V94.35a4.717 4.717 0 01-4.718 4.717H31.843a4.717 4.717 0 01-4.718-4.717V63.685a4.717 4.717 0 014.718-4.717h77.837zm-63.685 8.256c-6.513 0-11.794 5.28-11.794 11.793 0 6.514 5.28 11.794 11.794 11.794 6.513 0 11.794-5.28 11.794-11.794 0-6.513-5.28-11.793-11.794-11.793z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.767,
    height: 3.717,
    x: 65.365,
    y: 71.262,
    stroke: "#FFF",
    rx: 1.859
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.381,
    height: 3.717,
    x: 65.365,
    y: 83.055,
    stroke: "#FFF",
    rx: 1.859
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.201 67.224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.794,
    cy: 11.794,
    r: 11.794,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.794 12.973a9.439 9.439 0 018.964 6.483c-2.163 2.529-5.376 4.131-8.964 4.131s-6.802-1.602-8.965-4.13c1.24-3.766 4.785-6.484 8.965-6.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M10.144 14.152c4.18 0 7.725 2.719 8.964 6.484-.403.47-.842.91-1.314 1.312a11.731 11.731 0 01-6 1.64 11.768 11.768 0 01-8.965-4.131 9.443 9.443 0 012.69-4.095 9.39 9.39 0 014.625-1.21z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.794,
    cy: 8.256,
    r: 4.717,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.3,
    d: "M10.614 4.717a4.718 4.718 0 013.874 7.411A4.717 4.717 0 017.92 5.562a4.7 4.7 0 012.694-.845z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-11 2079.04 -10193.777)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.238,
    height: 68.429,
    stroke: "#FFF",
    strokeLinecap: "round",
    rx: 4.147
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M86.924 68.412H4.314A4.312 4.312 0 010 64.1v-2.292l33.526-33.584a4.314 4.314 0 016.1-.006l.005.006L60.61 49.24l11.267-11.287a4.314 4.314 0 016.1-.005l.005.005 13.254 13.278V64.1a4.312 4.312 0 01-4.313 4.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M86.924 68.412H4.314A4.312 4.312 0 010 64.1v-2.292l33.526-33.584a4.314 4.314 0 016.1-.006l.005.006L60.61 49.24l11.267-11.287a4.314 4.314 0 016.1-.005l.005.005 13.254 13.278V64.1a4.312 4.312 0 01-4.313 4.313z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.837,
    cy: 17.806,
    stroke: "#FFF",
    strokeLinecap: "round",
    rx: 7.555,
    ry: 7.568
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.837,
    cy: 17.806,
    fill: "#FFF",
    fillOpacity: 0.16,
    rx: 7.555,
    ry: 7.568
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M1771.117 159.078a5.132 5.132 0 016.086 3.953l8.47 39.847a5.132 5.132 0 01-3.953 6.086l-29.49 6.267-13.801 14.667a1.97 1.97 0 01-2.823.048c-.29-.284-.49-.65-.576-1.049l-2.036-9.578-10.683 2.272a5.132 5.132 0 01-6.086-3.953l-8.47-39.845a5.133 5.133 0 013.953-6.087l59.409-12.628zm-21.747 43.08c-1.277.272-2.1 1.498-1.836 2.738s1.514 2.026 2.791 1.754c1.279-.271 2.1-1.497 1.837-2.737-.264-1.24-1.513-2.026-2.792-1.754zm-5.49-25.83c-4.862 1.033-7.99 5.696-6.987 10.415.22 1.033 1.261 1.688 2.326 1.461s1.75-1.248 1.53-2.28l-.032-.174c-.454-2.592 1.286-5.11 3.959-5.679 2.732-.58 5.403 1.098 5.966 3.75.421 1.98-1.727 4.657-2.16 5.119-.434.46-.638.7-.895.982-1.112 1.347-1.885 3.165-1.72 5.017a1.89 1.89 0 00.042.415l.458 2.155.03.123c.273.962 1.274 1.557 2.296 1.34 1.066-.227 1.75-1.248 1.531-2.282l-.382-1.797-.031-.171a2.85 2.85 0 01.87-2.48c.333-.318 1.026-.929 1.235-1.129 2.191-2.07 3.22-5.116 2.583-8.112-1.003-4.719-5.757-7.707-10.62-6.673z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M1749.372 202.16c1.278-.272 2.527.512 2.791 1.752s-.558 2.466-1.837 2.738c-1.277.272-2.527-.514-2.79-1.754-.264-1.24.558-2.466 1.835-2.738zm-5.491-25.832c4.862-1.034 9.616 1.953 10.62 6.672.636 2.997-.393 6.044-2.584 8.113-.21.2-.902.811-1.235 1.128a2.844 2.844 0 00-.87 2.48l.031.172.382 1.796c.22 1.034-.466 2.056-1.531 2.283-1.022.217-2.023-.378-2.296-1.34l-.03-.123-.458-2.156a1.89 1.89 0 01-.041-.414c-.166-1.852.607-3.67 1.72-5.017.256-.282.46-.523.895-.983.433-.46 2.58-3.139 2.16-5.119-.564-2.65-3.235-4.33-5.967-3.75-2.673.569-4.413 3.089-3.96 5.68l.033.173c.22 1.033-.465 2.055-1.53 2.281s-2.107-.428-2.326-1.461c-1.003-4.719 2.125-9.382 6.987-10.415z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1770.76 159.364a5.132 5.132 0 016.086 3.952l8.398 39.508a5.132 5.132 0 01-3.953 6.087l-27.722 5.892-15.104 15.457a2.195 2.195 0 01-3.064.074 2.096 2.096 0 01-.615-1.09l-2.125-9.997-10.779 2.291a5.132 5.132 0 01-6.087-3.953l-8.397-39.507a5.132 5.132 0 013.952-6.087l59.41-12.628z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CategoryBackground_svg__b)",
    opacity: 0.244
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 1123.15 11622.143)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M62.38 21.773c0 11.93 9.671 21.6 21.6 21.6 3.457 0 6.723-.812 9.62-2.255v31.976a6.22 6.22 0 01-6.22 6.221H65.187v13.883c0 .612-.18 1.209-.515 1.716l-.133.186a3.11 3.11 0 01-4.21.671l-.153-.111-21.152-16.345H6.221A6.22 6.22 0 010 73.095v-49.66a6.22 6.22 0 016.22-6.22l56.643-.001a21.663 21.663 0 00-.482 4.558z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M62.208 21.773c0 12.025 9.748 21.773 21.773 21.773 3.34 0 6.503-.752 9.332-2.096l-.001 31.644a6.22 6.22 0 01-6.22 6.221H65.187v13.883c0 .612-.18 1.209-.515 1.716l-.133.186a3.11 3.11 0 01-4.21.671l-.153-.111-21.152-16.345H6.221A6.22 6.22 0 010 73.095V23.327a6.22 6.22 0 016.22-6.22h56.49a21.847 21.847 0 00-.501 4.665z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.981,
    cy: 21.773,
    r: 21.773,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.16,
    d: "M83.98 0l.36.003c11.86.192 21.414 9.865 21.414 21.77 0 5.654-2.844 11.493-7.107 16.093a21.698 21.698 0 01-14.666 5.68c-12.025 0-21.773-9.748-21.773-21.773A21.692 21.692 0 0167.9 7.094C72.498 2.838 78.33 0 83.98 0zm-9.775 12.447c-.392.108-1.879 1.522-2.293 2.669-.443 1.234-.494 2.694-.138 4.117a20.643 20.643 0 001.958 4.97 20.117 20.117 0 003.341 4.479 20.25 20.25 0 004.475 3.34 20.57 20.57 0 004.97 1.956c1.423.356 2.887.31 4.118-.137.716-.258 2.493-1.66 2.67-2.285.02-.07 0-.334-.268-.759-.403-.631-1.395-1.67-3.814-3.024a2.537 2.537 0 00-.407-.196c-.148.055-.519.316-.85.545-.435.305-1.03.719-1.845 1.216-.86.526-1.928.57-3.083.134a6.058 6.058 0 01-1.322-.697c-.23-.145-1.617-1.049-2.652-2.09-1.035-1.039-1.947-2.426-2.088-2.647a6.043 6.043 0 01-.698-1.325c-.436-1.158-.385-2.222.142-3.082.494-.803.904-1.398 1.206-1.83.236-.337.497-.715.552-.864-.011-.043-.055-.16-.196-.414-1.348-2.403-2.383-3.39-3.011-3.797-.436-.28-.701-.298-.767-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M74.071 11.965c.096-.027.49-.096 1.172.341.66.427 1.76 1.448 3.176 3.973.233.855-.069 1.36-.382 1.808a35.883 35.883 0 00-1.19 1.805c-.453.74-.472 1.656-.1 2.647.23.618.546 1.079.639 1.212.149.232 1.03 1.575 2.034 2.58 1 1.008 2.343 1.882 2.564 2.022.157.11.619.422 1.231.651.986.372 1.905.36 2.647-.093.802-.49 1.39-.898 1.82-1.2.446-.309.811-.548.964-.603 3.374 1.656 4.392 2.76 4.815 3.422.416.658.356 1.052.327 1.163-.2.702-2.168 2.325-2.982 2.618-1.318.478-2.885.534-4.41.153a21.146 21.146 0 01-5.09-2.004 20.753 20.753 0 01-4.588-3.426 20.627 20.627 0 01-3.424-4.59 21.093 21.093 0 01-2.005-5.09c-.381-1.524-.322-3.086.153-4.408.472-1.307 2.189-2.859 2.63-2.981z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M90.202 20.218a4.667 4.667 0 00-4.666-4.666m9.331 4.666c0-5.154-4.178-9.332-9.331-9.332"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.101,
    height: 5.221,
    x: 0.5,
    y: 0.5,
    stroke: "#FFF",
    rx: 2.61,
    transform: "translate(12.442 35.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.542,
    height: 5.221,
    x: 0.5,
    y: 0.5,
    stroke: "#FFF",
    rx: 2.61,
    transform: "translate(12.442 54.432)"
  }))))));
}

export default SvgCategoryBackground;